import { Messages } from '../../../codegen/Localize';
import { Order } from '../../helpers/Order';
import { OrderKeys } from '../OrderKeys';
import { NoMessage } from './CatalogSortOptions';
import { OptionDefinition } from './SortOptionDefinitions';

export namespace CrassSortOptions {
  export const downstreamWorkbookCount: OptionDefinition = {
    id: 'workbooks',
    getMenuItemDisplayValue: Messages.column_numWorkbooks,
    subSortOptions: {
      desc: {
        id: 'downstreamWorkbookCount.desc',
        field: OrderKeys.downstreamWorkbookCount,
        getMenuItemDisplayValue: Messages.sortByMostLeast,
        getButtonDisplayValue: Messages.sortByNumWorkbooksDesc,
        ascending: false,
        toOrderClauseArray: () => [
          Order.desc(OrderKeys.downstreamWorkbookCount),
          Order.asc(OrderKeys.name),
        ],
      },
      asc: {
        id: 'downstreamWorkbookCount.asc',
        field: OrderKeys.downstreamWorkbookCount,
        getMenuItemDisplayValue: Messages.sortByLeastMost,
        getButtonDisplayValue: Messages.sortByNumWorkbooksAsc,
        ascending: true,
        toOrderClauseArray: () => [
          Order.asc(OrderKeys.downstreamWorkbookCount),
          Order.asc(OrderKeys.name),
        ],
      },
    },
  };

  export const downstreamDataSourceCount: OptionDefinition = {
    id: 'datasources',
    getMenuItemDisplayValue: Messages.sortByDataSourcesCount,
    subSortOptions: {
      desc: {
        id: 'downstreamDataSourceCount.desc',
        field: OrderKeys.downstreamDataSourceCount,
        getMenuItemDisplayValue: Messages.sortByMostLeast,
        getButtonDisplayValue: Messages.sortByNumDatasourcesDesc,
        ascending: false,
        toOrderClauseArray: () => [
          Order.desc(OrderKeys.downstreamDataSourceCount),
          Order.asc(OrderKeys.name),
        ],
      },
      asc: {
        id: 'downstreamDataSourceCount.asc',
        field: OrderKeys.downstreamDataSourceCount,
        getMenuItemDisplayValue: Messages.sortByLeastMost,
        getButtonDisplayValue: Messages.sortByNumDatasourcesAsc,
        ascending: true,
        toOrderClauseArray: () => [
          Order.asc(OrderKeys.downstreamDataSourceCount),
          Order.asc(OrderKeys.name),
        ],
      },
    },
  };

  export const connectionType: OptionDefinition = {
    id: 'connection-type',
    getMenuItemDisplayValue: Messages.column_connection_type,
    subSortOptions: {
      asc: {
        id: 'connectionType.asc',
        field: OrderKeys.connectionTypeDisplayNameCrass,
        getMenuItemDisplayValue: Messages.sortByAZ,
        getButtonDisplayValue: Messages.sortByConnectionTypeAsc,
        ascending: true,
        toOrderClauseArray: () => [
          Order.asc(OrderKeys.connectionTypeDisplayNameCrass),
          Order.asc(OrderKeys.name),
        ],
      },
      desc: {
        id: 'connectionType.desc',
        field: OrderKeys.connectionTypeDisplayNameCrass,
        getMenuItemDisplayValue: Messages.sortByZA,
        getButtonDisplayValue: Messages.sortByConnectionTypeDesc,
        ascending: false,
        toOrderClauseArray: () => [
          Order.desc(OrderKeys.connectionTypeDisplayNameCrass),
          Order.asc(OrderKeys.name),
        ],
      },
    },
  };

  export const isCertified: OptionDefinition = {
    id: 'is-certified',
    getMenuItemDisplayValue: Messages.column_certification,
    subSortOptions: {
      'asc': {
        id: 'isCertified.asc',
        field: OrderKeys.isCertified,
        ascending: true,
        getMenuItemDisplayValue: NoMessage,
        toOrderClauseArray: () => [Order.asc(OrderKeys.isCertified)],
      },
      'desc': {
        id: 'isCertified.desc',
        field: OrderKeys.isCertified,
        ascending: false,
        getMenuItemDisplayValue: NoMessage,
        toOrderClauseArray: () => [Order.desc(OrderKeys.isCertified)],
      }
    }
  };
}
